import _ from "lodash";
import * as Actions from "../Actions/CompartilharActions";

const initialState = {
    error: null,
    info: null,
    warning: null,
    profissionaisempresa: null,
    compartilhardocumento: null,
};

const CompartilharReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.COMPARTILHAR_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.COMPARTILHAR_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    id: action.id
                };
            }
        case Actions.COMPARTILHAR_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.GET_PROFISSIONAISEMPRESA:
            {
                return {
                    ...state,
                    profissionaisempresa: action.payload
                };
            }
        case Actions.GET_COMPARTILHARDOCUMENTO:
            {
                return {
                    ...state,
                    compartilhardocumento: !_.isNull(action.payload) ? action.payload[0] : action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default CompartilharReducer;
